/**
 * 說明 : 梯控歷史記錄資料與後端API調用的非同步行為
 */
import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

// 取得梯控歷史記錄清單列表
export const fetchElevCtrlHistoryList = createAsyncThunk(
  'elevCtrlHistory/fetchElevCtrlHistoryList',
  async ({buildingId, elevatorId, userName, startDate, endDate}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth('/elevMgmt/history', {buildingId: buildingId, elevatorId: elevatorId, userName: userName, startDate: startDate, endDate: endDate}, token);
      return data;
    } catch (err) {
      console.error('fetch elevator control histories error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
